import type { CustomerReservationDetailsStore } from '@iheartjane/data-access';

// eslint-disable-next-line no-restricted-imports
import type {
  CartStore,
  NoStore,
  Store,
  StoreHeaderStore,
} from '@jane/shared/models';

export const isStore = (
  x:
    | Store
    | CustomerReservationDetailsStore
    | StoreHeaderStore
    | CartStore
    | NoStore
): x is
  Store | CustomerReservationDetailsStore | StoreHeaderStore | CartStore =>
  x != null && !('noStore' in x);
